// This file is auto-generated. Do not edit manually.

import { DiagnosticAccessorBase } from './DiagnosticAccessorBase';
import { DiagnosticReponse } from '../DiagnosticReponse';
import { scoringQuestionsByGroup } from './diagnostic';

/**
 * Create a mapping from group names to their getter lambdas.
 * Used by computeHandiToitScore to efficiently access diagnostic field values by group.
 */
export function createDiagnosticGettersByGroup(accessor: DiagnosticAccessorBase): Record<string, Array<() => DiagnosticReponse | undefined>> {
  const getters: Record<string, () => DiagnosticReponse | undefined> = {
    'chemExtPietonExt': () => accessor.chemExtPietonExt?.get(),
    'chemExtPietonParking': () => accessor.chemExtPietonParking?.get(),
    'chemExtPortillonManu': () => accessor.chemExtPortillonManu?.get(),
    'chemExtPortillonAuto': () => accessor.chemExtPortillonAuto?.get(),
    'chemExtPortillonTele': () => accessor.chemExtPortillonTele?.get(),
    'communHallColectif': () => accessor.communHallColectif?.get(),
    'communLocalVelo': () => accessor.communLocalVelo?.get(),
    'communPorteVoie': () => accessor.communPorteVoie?.get(),
    'communPorteResidence': () => accessor.communPorteResidence?.get(),
    'communPorteAuto': () => accessor.communPorteAuto?.get(),
    'communPorteTele': () => accessor.communPorteTele?.get(),
    'communOuvManu': () => accessor.communOuvManu?.get(),
    'communPorteFourreau': () => accessor.communPorteFourreau?.get(),
    'communDispoHaut': () => accessor.communDispoHaut?.get(),
    'communDispoAngle': () => accessor.communDispoAngle?.get(),
    'communDispoSonore': () => accessor.communDispoSonore?.get(),
    'communDispoCamera': () => accessor.communDispoCamera?.get(),
    'communDispoSansFil': () => accessor.communDispoSansFil?.get(),
    'communHallSup1m20': () => accessor.communHallSup1m20?.get(),
    'communHallSup1m50': () => accessor.communHallSup1m50?.get(),
    'communHallEclairageAuto': () => accessor.communHallEclairageAuto?.get(),
    'communHallEclairage90': () => accessor.communHallEclairage90?.get(),
    'communAscenseurPalier': () => accessor.communAscenseurPalier?.get(),
    'communAscenseurBouton': () => accessor.communAscenseurBouton?.get(),
    'communAscenseurNorme': () => accessor.communAscenseurNorme?.get(),
    'communAscenseurNormeType3': () => accessor.communAscenseurNormeType3?.get(),
    'communAscenseurHori': () => accessor.communAscenseurHori?.get(),
    'communAscenseurCommandeVert': () => accessor.communAscenseurCommandeVert?.get(),
    'communAscenseurMainCourante': () => accessor.communAscenseurMainCourante?.get(),
    'communAscenseurMiroir': () => accessor.communAscenseurMiroir?.get(),
    'communBoiteLettre': () => accessor.communBoiteLettre?.get(),
    'communBoiteUsage': () => accessor.communBoiteUsage?.get(),
    'communBoiteManoeuvre': () => accessor.communBoiteManoeuvre?.get(),
    'communBoiteEclairage': () => accessor.communBoiteEclairage?.get(),
    'statioDedie': () => accessor.statioDedie?.get(),
    'statioProxi': () => accessor.statioProxi?.get(),
    'statioSousSol': () => accessor.statioSousSol?.get(),
    'statioSousSolBoxe': () => accessor.statioSousSolBoxe?.get(),
    'statioSousSolOuvert': () => accessor.statioSousSolOuvert?.get(),
    'statioSousSolArceaux': () => accessor.statioSousSolArceaux?.get(),
    'statioSousSolMotorise': () => accessor.statioSousSolMotorise?.get(),
    'statioSasInt': () => accessor.statioSasInt?.get(),
    'statioSasSup1m20': () => accessor.statioSasSup1m20?.get(),
    'statioSasSup1m50': () => accessor.statioSasSup1m50?.get(),
    'statioSasOculus': () => accessor.statioSasOculus?.get(),
    'statioSurface': () => accessor.statioSurface?.get(),
    'statioSurfaceArceaux': () => accessor.statioSurfaceArceaux?.get(),
    'statioSurfaceMotorise': () => accessor.statioSurfaceMotorise?.get(),
    'statioVisiteur': () => accessor.statioVisiteur?.get(),
    'entreeLargeur83': () => accessor.entreeLargeur83?.get(),
    'entreeLargeur': () => accessor.entreeLargeur?.get(),
    'entreeSerrure': () => accessor.entreeSerrure?.get(),
    'entreePoignee': () => accessor.entreePoignee?.get(),
    'entreePoigneeRallongee': () => accessor.entreePoigneeRallongee?.get(),
    'entreeEspaceManoeuvre': () => accessor.entreeEspaceManoeuvre?.get(),
    'entreeAuto': () => accessor.entreeAuto?.get(),
    'entreeEclairage': () => accessor.entreeEclairage?.get(),
    'dispositifHauteur130': () => accessor.dispositifHauteur130?.get(),
    'dispositifHanteur90': () => accessor.dispositifHanteur90?.get(),
    'dispositifAngle': () => accessor.dispositifAngle?.get(),
    'dispositifFourreauVolets': () => accessor.dispositifFourreauVolets?.get(),
    'dispositifVoletElec': () => accessor.dispositifVoletElec?.get(),
    'dispositifVoletInterrupteur': () => accessor.dispositifVoletInterrupteur?.get(),
    'dispositifVoletTelecommande': () => accessor.dispositifVoletTelecommande?.get(),
    'dispositifManoeuvreSecours': () => accessor.dispositifManoeuvreSecours?.get(),
    'dispositifPrisesHautes': () => accessor.dispositifPrisesHautes?.get(),
    'dispositifPrisesBasses': () => accessor.dispositifPrisesBasses?.get(),
    'generalLargeurSup90': () => accessor.generalLargeurSup90?.get(),
    'generalLargeurEgal120': () => accessor.generalLargeurEgal120?.get(),
    'generalLargeurSup120': () => accessor.generalLargeurSup120?.get(),
    'generalLargeurPorte83': () => accessor.generalLargeurPorte83?.get(),
    'generalLargeurPorte90': () => accessor.generalLargeurPorte90?.get(),
    'generalPoignetPorte': () => accessor.generalPoignetPorte?.get(),
    'generalPoigneeRallongee': () => accessor.generalPoigneeRallongee?.get(),
    'generalEspaceManoeuvre': () => accessor.generalEspaceManoeuvre?.get(),
    'generalPlacardAdapte': () => accessor.generalPlacardAdapte?.get(),
    'generalPrisesHautes': () => accessor.generalPrisesHautes?.get(),
    'generalPrisesBasses': () => accessor.generalPrisesBasses?.get(),
    'cuisineOuverte': () => accessor.cuisineOuverte?.get(),
    'cuisineLargeurPorte83': () => accessor.cuisineLargeurPorte83?.get(),
    'cuisineLargeurPorte90': () => accessor.cuisineLargeurPorte90?.get(),
    'cuisinePoignetPorte': () => accessor.cuisinePoignetPorte?.get(),
    'cuisinePoigneeRallongee': () => accessor.cuisinePoigneeRallongee?.get(),
    'cuisineEspaceManoeuvre': () => accessor.cuisineEspaceManoeuvre?.get(),
    'cuisinePassage': () => accessor.cuisinePassage?.get(),
    'cuisineEspace': () => accessor.cuisineEspace?.get(),
    'cuisineProfondeur': () => accessor.cuisineProfondeur?.get(),
    'cuisineSiphon': () => accessor.cuisineSiphon?.get(),
    'cuisineCuve': () => accessor.cuisineCuve?.get(),
    'cuisinePlanTravail': () => accessor.cuisinePlanTravail?.get(),
    'cuisinePrisesCredence': () => accessor.cuisinePrisesCredence?.get(),
    'terrasseAcces': () => accessor.terrasseAcces?.get(),
    'terrasseFourreau': () => accessor.terrasseFourreau?.get(),
    'terrasseRessaut': () => accessor.terrasseRessaut?.get(),
    'terrasseRampe': () => accessor.terrasseRampe?.get(),
    'jardinAcces': () => accessor.jardinAcces?.get(),
    'jardinRampe': () => accessor.jardinRampe?.get(),
    'chambreLargeurPorte80': () => accessor.chambreLargeurPorte80?.get(),
    'chambreLargeurPorte90': () => accessor.chambreLargeurPorte90?.get(),
    'chambrePoignetPorte': () => accessor.chambrePoignetPorte?.get(),
    'chambrePoigneeRallongee': () => accessor.chambrePoigneeRallongee?.get(),
    'chambreEspaceManoeuvre': () => accessor.chambreEspaceManoeuvre?.get(),
    'chambreDiametre': () => accessor.chambreDiametre?.get(),
    'chambrePassage': () => accessor.chambrePassage?.get(),
    'chambrePlacardAdapte': () => accessor.chambrePlacardAdapte?.get(),
    'chambrePrisesHautes': () => accessor.chambrePrisesHautes?.get(),
    'chambrePrisesBasses': () => accessor.chambrePrisesBasses?.get(),
    'chambresLargeurPorte80': () => accessor.chambresLargeurPorte80?.get(),
    'chambresLargeurPorte90': () => accessor.chambresLargeurPorte90?.get(),
    'chambresPoignetPorte': () => accessor.chambresPoignetPorte?.get(),
    'chambresPoigneeRallongee': () => accessor.chambresPoigneeRallongee?.get(),
    'chambresEspaceManoeuvre': () => accessor.chambresEspaceManoeuvre?.get(),
    'chambresRetournement': () => accessor.chambresRetournement?.get(),
    'chambresPrisesHautes': () => accessor.chambresPrisesHautes?.get(),
    'chambresPrisesBasses': () => accessor.chambresPrisesBasses?.get(),
    'bainLargeurPorte80': () => accessor.bainLargeurPorte80?.get(),
    'bainLargeurPorte90': () => accessor.bainLargeurPorte90?.get(),
    'bainPoignetPorte': () => accessor.bainPoignetPorte?.get(),
    'bainPoigneeRallongee': () => accessor.bainPoigneeRallongee?.get(),
    'bainEspaceManoeuvre': () => accessor.bainEspaceManoeuvre?.get(),
    'salleBainEspace': () => accessor.salleBainEspace?.get(),
    'doucheCloisons': () => accessor.doucheCloisons?.get(),
    'bainPrisesHautes': () => accessor.bainPrisesHautes?.get(),
    'bainPrisesBasses': () => accessor.bainPrisesBasses?.get(),
    'doucheReceveurSansRessaut': () => accessor.doucheReceveurSansRessaut?.get(),
    'doucheItalienne': () => accessor.doucheItalienne?.get(),
    'doucheItalienneOk': () => accessor.doucheItalienneOk?.get(),
    'doucheReceveurEncastre': () => accessor.doucheReceveurEncastre?.get(),
    'doucheReceveurEncastreOk': () => accessor.doucheReceveurEncastreOk?.get(),
    'doucheBarreAppui': () => accessor.doucheBarreAppui?.get(),
    'doucheSiege': () => accessor.doucheSiege?.get(),
    'doucheParois': () => accessor.doucheParois?.get(),
    'lavaboUsage': () => accessor.lavaboUsage?.get(),
    'lavaboHauteurReglable': () => accessor.lavaboHauteurReglable?.get(),
    'lavaboHauteur': () => accessor.lavaboHauteur?.get(),
    'lavaboLibreSous': () => accessor.lavaboLibreSous?.get(),
    'lavaboProfondeur': () => accessor.lavaboProfondeur?.get(),
    'lavaboSiphon': () => accessor.lavaboSiphon?.get(),
    'wcSepare': () => accessor.wcSepare?.get(),
    'wcLargeurPorte80': () => accessor.wcLargeurPorte80?.get(),
    'wcLargeurPorte90': () => accessor.wcLargeurPorte90?.get(),
    'wcPoignetPorte': () => accessor.wcPoignetPorte?.get(),
    'wcPoigneeRallongee': () => accessor.wcPoigneeRallongee?.get(),
    'wcEspaceManoeuvre': () => accessor.wcEspaceManoeuvre?.get(),
    'wcEspace': () => accessor.wcEspace?.get(),
    'wcCloison': () => accessor.wcCloison?.get(),
    'wcHauteur': () => accessor.wcHauteur?.get(),
    'wcSuspendu': () => accessor.wcSuspendu?.get(),
    'wcBarreAppui': () => accessor.wcBarreAppui?.get(),
    'wcPrisesHautes': () => accessor.wcPrisesHautes?.get(),
    'wcPrisesBasses': () => accessor.wcPrisesBasses?.get(),
  };

  // Map group names to their getter arrays
  const result: Record<string, Array<() => DiagnosticReponse | undefined>> = {};
  for (const [groupName, questionIds] of Object.entries(scoringQuestionsByGroup)) {
    result[groupName] = questionIds.map(qId => getters[qId]).filter(g => g !== undefined);
  }
  return result;
}
